import React, { Fragment } from "react";
import { withTranslation } from "react-i18next";
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import { Col, Row } from "reactstrap";
import { Bar, HorizontalBar } from 'react-chartjs-2';
import PageTitle from "Layout/Components/PageTitle";
import BoxValue from "./BoxValue";
import { statisticsDash } from "API/StatisticsAPI";

class StatisticsDashboard extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            numberClients: 0,
            numberRequests: 0,
            numberReportedMalicious: 0,
            numberReportedLegitimate: 0,
            maliciousDetectionRate: 0
        };
    }

    componentDidMount() {
        statisticsDash().then(result => {
            this.setState({
                numberClients: result.number_clients,
                numberRequests: result.number_requests,
                numberReportedMalicious: result.number_reported_malicious,
                numberReportedLegitimate: result.number_reported_legitimate,
                maliciousDetectionRate: (result.number_reported_malicious /
                    (result.number_reported_malicious + result.number_reported_legitimate) * 100).toFixed(2)
            });
        }).catch((error) => {
            console.error("Error fetching statistics data:", error);
        });
    }

    render() {
        const { t, i18n } = this.props;

        const { numberClients, numberRequests, numberReportedMalicious, numberReportedLegitimate, maliciousDetectionRate } = this.state;

        const maliciousVsLegitimateData = {
            datasets: [
                {
                    label: t("statistics.malicious"),
                    data: [numberReportedMalicious],
                    backgroundColor: "#fb4c2f",
                    borderWidth: 1,
                    fill: true,
                },
                {
                    label: t("statistics.legitimate"),
                    data: [numberReportedLegitimate],
                    backgroundColor: "#76a96c",
                    borderWidth: 1,
                    fill: true,
                }
            ]
        };

        const requestsVsReportsData = {
            labels: [t("statistics.requests"), t("statistics.malicious"), t("statistics.legitimate")],
            datasets: [
                {
                    label: t("statistics.requests"),
                    data: [numberRequests, numberReportedMalicious, numberReportedLegitimate],
                    backgroundColor: ["#2980b9", "#fb4c2f", "#76a96c"],
                    borderWidth: 1,
                    fill: true,
                }
            ]
        };

        return (
            <Fragment>
                <PageTitle
                    heading={t("statistics.dashboard.title")}
                    icon="pe-7s-graph2 icon-gradient bg-primary"
                />
                <CSSTransitionGroup
                    component="div"
                    transitionName="TabsAnimation"
                    transitionAppear={true}
                    transitionAppearTimeout={0}
                    transitionEnter={false}
                    transitionLeave={false}>
                    <Row>
                        <Col md="3">
                            <BoxValue heading={t("statistics.client")} value={numberClients} color="ev-blue" textColor="ev-white" />
                        </Col>
                        <Col md="3">
                            <BoxValue heading={t("statistics.total-requests")} value={numberRequests} color="ev-green" textColor="ev-white" />
                        </Col>
                        <Col md="3">
                            <BoxValue heading={t("statistics.malicious-urls")} value={numberReportedMalicious} color="ev-red" textColor="ev-white" />
                        </Col>
                        <Col md="3">
                            <BoxValue heading={t("statistics.legitimate-urls")} value={numberReportedLegitimate} color="ev-yellow" textColor="ev-white" />
                        </Col>
                    </Row>
                    <Row>
                        <Col md="6">
                            <div className="text-center">
                                <h5>{t("statistics.malicious-vs-legitimate")}</h5>
                            </div>
                            <HorizontalBar height={175}
                                data={maliciousVsLegitimateData}
                                options={{
                                    maintainAspectRatio: true,
                                    scales: {
                                        xAxes: [
                                            {
                                                ticks: {
                                                    beginAtZero: true,
                                                    stepSize: 1
                                                },
                                            },
                                        ],
                                    }
                                }}
                            />
                        </Col>
                        <Col md="6">
                            <div className="text-center">
                                <h5>{t("statistics.request-vs-reported")}</h5>
                            </div>
                            <Bar height={125}
                                data={requestsVsReportsData}
                                options={{
                                    maintainAspectRatio: true,
                                    scales: {
                                        yAxes: [
                                            {
                                                ticks: {
                                                    beginAtZero: true,
                                                    min: 0,
                                                },
                                            },
                                        ],
                                    }
                                }}
                            />
                            <BoxValue heading={t("statistics.malicious-detection-rate")} value={maliciousDetectionRate + ' %'} color="ev-blue" textColor="ev-white" />
                        </Col>
                    </Row>
                </CSSTransitionGroup>
            </Fragment>
        )
    }
}

export default withTranslation()(StatisticsDashboard);